import { Link } from "react-router-dom"
import { useEffect } from "react"
import AOS from "aos"
import "aos/dist/aos.css"
import "./AboutPage.css"

function AboutPage(){

useEffect(()=>{
AOS.init({ duration:1000, once:true })
},[])

return(

<div className="aboutPage">

{/* HERO */}

<section
className="aboutHero"
style={{backgroundImage:"url(/images/about-banner.png)"}}
>

<div className="heroOverlay">

<h1 className="heroTitle">
Premium Lace, Gota Patti & Embroidery Materials
</h1>

<p className="heroText">
LaceGota is a trusted supplier of high-quality lace trims,
gota patti designs, decorative latkans and embroidery
materials used by boutique designers and fashion houses.
</p>

<Link to="/shop" className="heroBtn">
Explore Collection
</Link>

</div>

</section>


{/* BRAND TRUST */}

<section className="brandSection">

<h2>Trusted by Boutique Designers</h2>

<p className="brandText">
Our lace and embroidery accessories are widely used by
fashion designers, tailoring studios and boutique owners
who require premium quality materials for bridal wear,
designer sarees and ethnic garments.
</p>

<div className="brandLogos">

<img src="/images/logo1.jpg" alt="designer"/>
<img src="/images/logo2.jpg" alt="designer"/>
<img src="/images/logo3.webp" alt="designer"/>
<img src="/images/logo4.jpg" alt="designer"/>
<img src="/images/logo5.webp" alt="designer"/>

</div>

</section>


{/* STORY */}

<section className="aboutIntro">

<div className="introImages">

<img src="/images/saree-lace.jpg" alt="" className="img1"/>
<img src="/images/gota-patti.jpg" alt="" className="img2"/>

</div>

<div className="introText">

<h2>Our Story</h2>

<p>
LaceGota was created with the vision of providing
premium lace trims and embroidery accessories to
boutique designers and fashion businesses.
</p>

<p>
Over the years we have built strong relationships
with designers who rely on our materials for creating
beautiful garments and designer collections.
</p>

<p>
From bridal wear to couture fashion,
our products add elegance and craftsmanship
to every design.
</p>

</div>

</section>


{/* WHY CHOOSE US */}

<section className="whySection">

<h2>Why Choose LaceGota</h2>

<div className="whyGrid">

<div className="whyCard">

<h3>Premium Quality</h3>

<p>
We carefully source lace and embroidery materials
to ensure the highest standards of quality and
durability for designers.
</p>

</div>

<div className="whyCard">

<h3>Wide Product Range</h3>

<p>
Our collection includes lace trims, gota patti,
zari borders, latkan tassels and decorative
embroidery accessories.
</p>

</div>

<div className="whyCard">

<h3>Trusted by Designers</h3>

<p>
Hundreds of boutique designers trust our
products to create unique and elegant garments.
</p>

</div>

<div className="whyCard">

<h3>Fast Delivery</h3>

<p>
We ensure fast shipping and reliable service
so designers can complete their projects on time.
</p>

</div>

</div>

</section>


{/* PRODUCT SHOWCASE */}

<section className="productSection">

<h2>Our Premium Lace Collection</h2>

<p className="collectionText">
Explore our exclusive range of designer lace,
velvet lace trims, zari borders and decorative
embroidery accessories perfect for boutique fashion.
</p>

<div className="sliderTrack">

<img src="/images/saree-lace.jpg" alt="lace"/>
<img src="/images/velvet-lace.webp" alt="lace"/>
<img src="/images/zari-border.jpg" alt="lace"/>
<img src="/images/zari-trim.webp" alt="lace"/>

<img src="/images/saree-lace.jpg" alt="lace"/>
<img src="/images/velvet-lace.webp" alt="lace"/>
<img src="/images/zari-border.jpg" alt="lace"/>
<img src="/images/zari-trim.webp" alt="lace"/>

</div>

</section>


{/* FOUNDER */}

<section className="founderSection">

<div className="founderContainer">

<img
src="/images/banner7.webp"
alt="Founder"
className="founderImg"
/>

<div>

<h2>Message from the Founder</h2>

<p>
Our goal has always been to provide premium
lace materials that inspire creativity in fashion.
Every product we offer is selected with attention
to detail and quality.
</p>

<p>
We believe that beautiful fashion starts
with beautiful materials.
</p>

<p>
Thank you for trusting LaceGota and being
part of our journey.
</p>

</div>

</div>

</section>


{/* TESTIMONIAL */}

<section
className="testimonial"
style={{backgroundImage:"url(/images/velvet-lace.webp)"}}
>

<div className="testimonialOverlay">

<h2>What Our Customers Say</h2>

<p className="stars">★★★★★</p>

<p>
Excellent lace quality and fast delivery.
Perfect for boutique designers and fashion tailoring.
</p>

<h4>Lalita Arora</h4>

<span>Fashion Designer</span>

</div>

</section>


{/* CTA */}

<section
className="aboutCTA"
style={{backgroundImage:"url(/images/saree-lace.jpg)"}}
>

<div className="ctaOverlay">

<h2>Explore Our Lace Collection</h2>

<p>
Browse our premium range of lace trims,
gota patti and embroidery materials.
</p>

<Link to="/shop" className="ctaBtn">
Shop Now
</Link>

</div>

</section>

</div>

)

}

export default AboutPage